import React,{ useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as actionTypes from '../../redux/actions/actionTypes';
import SideBar from '../SideBar/SideBar';
import Content from '../Content/Content';
import ThankYou from '../ThankYou/ThankYou';
import Preventivatore from '../Preventivatore/Preventivatore';
import Loading from '../../components/Loading/Loading';

import getCalcoloPreventivo from '../../redux/actions/mock/getCalcoloPreventivo';
import getApiData from '../../redux/actions/mock/getApiData';
import documentiTrasparenza from '../../redux/actions/mock/documentiTrasparenza';
import getDatiByTokenInBank from '../../redux/actions/mock/getDatiByTokenInBank';

const Container = () => {


    let search = window.location.search;
    let params = new URLSearchParams(search);

    let tokenInBank = params.get('data');
    let uuidGetParam = params.get('uuid');
    let importoGetParam = params.get('importoRata');
    let mesiGetParam = params.get('durata');
    let codiceBrokerGetParam = params.get('codiceBroker');

    const apiPath = useSelector(state => state.dataReducer.dataApiPath);

    //const uuid = useSelector(state => state.dataReducer.modello.id);
    const steps = useSelector(state => state.dataReducer.modello.currentStep);
    //const erroreApi = useSelector(state => state.dataReducer.salvaDatiIniziali.erroreControllo);
    const dispatch = useDispatch();

    const datiPreventivo = useSelector(state => state.dataReducer.modello.datiPratica);
    const codiceBroker = useSelector(state => state.dataReducer.modello.codiceBroker);
    //const importoStato = useSelector(state => state.dataReducer.modello.datiPratica.importo);

    const erroreUuidGet = useSelector(state => state.dataReducer.erroreUuid.dati);
    const loadingUuidGet = useSelector(state => state.dataReducer.load.loadingUuidGet);

    let importo = datiPreventivo.importo;
    let numeroRate = datiPreventivo.numeroRate;
    let progetto = datiPreventivo.progetto || null;
    let assicurazione = datiPreventivo.assicurazione || false;


    useEffect(
        () => {
            function loadData(){
                dispatch({type: actionTypes.LOADING_INIZIALE_TRUE});
                if(uuidGetParam !== null && importoGetParam === null && codiceBrokerGetParam === null){
                    dispatch({type: actionTypes.INIT_UUID, payload: uuidGetParam});
                }else if(uuidGetParam === null && importoGetParam !== null && codiceBrokerGetParam !== null){
                    dispatch({ type: actionTypes.SALVA_DATI_GET_PREVENTIVO, importo: Number(importoGetParam), numeroRate: Number(mesiGetParam), codice: codiceBrokerGetParam });
                }else if(uuidGetParam === null && importoGetParam === null && codiceBrokerGetParam !== null){
                    dispatch({ type: actionTypes.SALVA_CODICE_BROKER, codice: codiceBrokerGetParam});
                }
                dispatch({type: actionTypes.LOADING_INIZIALE_FALSE});
            }
            loadData();
        }
    , [uuidGetParam,importoGetParam,codiceBrokerGetParam, tokenInBank]); // eslint-disable-line

    useEffect(
        () => {
            if(tokenInBank && codiceBroker){
                dispatch(getDatiByTokenInBank(tokenInBank,codiceBrokerGetParam,apiPath));
            }
        }
    , [tokenInBank, codiceBroker]); // eslint-disable-line


    useEffect(
        () => {
            if(codiceBroker){
                dispatch({type: actionTypes.LOADING_PREVENTIVO_TRUE});
                dispatch(getCalcoloPreventivo(importo,numeroRate,progetto,assicurazione,codiceBroker,apiPath)); 
                dispatch(documentiTrasparenza(apiPath));
            }
        }
    , [codiceBroker]); // eslint-disable-line
    
    useEffect(
        () => {
            if(uuidGetParam !== null){
                dispatch({type: actionTypes.LOADING_UUIDGET_TRUE});
                dispatch(getApiData(uuidGetParam,apiPath));
            }
        }
    , [uuidGetParam, apiPath]); // eslint-disable-line


    return(
        <div>
            {
                loadingUuidGet === true ? (

                    <Loading loading={loadingUuidGet} />
                    
                ) : erroreUuidGet && erroreUuidGet.errorCode === "uuid" ? (

                    <ThankYou risultato='error' />
                
                ) : (

                    ( steps === 0 ) ? (

                        <Preventivatore />
                        
                    )
                    : ( steps > 0 && steps < 14 ) ? 
                    (
                        <>
                            <SideBar />
                            <Content />
                        </>

                    ) : (steps === 14) ? (
                        
                        <ThankYou risultato='success' type='primary' />

                    ) : (steps === 15) ? (
                        <>
                            <SideBar />
                            <Content />
                        </>
                    ) : (steps === 16) ? (
                        <ThankYou risultato='success' type='secondary' />
                    ) : null

                )

            }
        </div>
    )
}

export default Container;